/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import ConversationsaddChatParticipantConversation from './ConversationsaddChatParticipantConversation';

/**
 * The ConversationsAddChatParticipantBody model module.
 * @module model/ConversationsAddChatParticipantBody
 * @version v0.3
 */
export default class ConversationsAddChatParticipantBody {
  /**
   * Constructs a new <code>ConversationsAddChatParticipantBody</code>.
   * @alias module:model/ConversationsAddChatParticipantBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ConversationsAddChatParticipantBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ConversationsAddChatParticipantBody} obj Optional instance to populate.
   * @return {module:model/ConversationsAddChatParticipantBody} The populated <code>ConversationsAddChatParticipantBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ConversationsAddChatParticipantBody();
      if (data.hasOwnProperty('conversation'))
        obj.conversation = ConversationsaddChatParticipantConversation.constructFromObject(data['conversation']);
    }
    return obj;
  }
}

/**
 * @member {module:model/ConversationsaddChatParticipantConversation} conversation
 */
ConversationsAddChatParticipantBody.prototype.conversation = undefined;

